"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_73_39_0 = void 0;
/**
 * Migrate to 73.39.0
 *
 * add IAZeichnungsnummer to config and remove from Kette
 *
 */
const migration_73_39_0 = (json) => {
    var _a, _b;
    const copyIANummer = (_a = json.Kette) === null || _a === void 0 ? void 0 : _a.IAZeichnungsnummer;
    if (copyIANummer) {
        json.IAZeichnungsnummer = copyIANummer;
        (_b = json.Kette) === null || _b === void 0 ? true : delete _b.IAZeichnungsnummer;
    }
    return json;
};
exports.migration_73_39_0 = migration_73_39_0;
//# sourceMappingURL=migration_73_39_0.js.map